import type { TOC } from '@ember/component/template-only';
import BvBadge, { type BvBadgeArgs } from 'volta/components/bv-badge';
import BvInline from 'volta/components/bv-inline';
import BvIcon, { type BvIconSignature } from 'volta/components/bv-icon';
import BvText from 'volta/components/bv-text';

interface Signature {
  Args: {
    option: {
      icon: BvIconSignature['Args']['glyph'];
      label?: string;
      color: BvBadgeArgs['color'];
    };
  };
}

const Item: TOC<Signature> = <template>
  <BvBadge @color={{@option.color}}>
    <BvInline @blockAlign='center' @gap='1'>
      <BvIcon @glyph={{@option.icon}} @size='sm' />
      <BvText class='u-ellipsis' @text={{@option.label}} />
    </BvInline>
  </BvBadge>
</template>;

export default Item;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workshops::WorkshopTypeSelect::Item': typeof Item;
    'workshops/workshop-type-select/item': typeof Item;
  }
}
